module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Avietchii/Tokyo_Avietchii_MIROC5_RCP45_End.png";